import { Offcanvas } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'context/AuthContext';
import { hasUserAccess } from 'utils/helpers/access/hasUserAccess';
import SpinnerBlock from 'components/others/SpinnerBlock';
import WarrantyFormik from './WarrantyFormik';
import WarrantyForm from './WarrantyForm';
import { useWarrantyCard } from './model';

interface OffWarrantyCardProps {
    id: number;
    onClose: () => void;
    onSaved: () => void;
}

const OffWarrantyCard = ({ id, onClose, onSaved }: OffWarrantyCardProps) => {
    const { t } = useTranslation('Warranties');
    const { auth } = useAuth();
    const card = useWarrantyCard(id, onSaved, onClose);
    return (
        <Offcanvas show placement="end" onHide={onClose} className="off-warranty">
            <Offcanvas.Header className="border-bottom" closeButton>
                <Offcanvas.Title>{t('cardTitle')}</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className="pb-0 px-0 d-flex flex-column position-relative">
                <SpinnerBlock
                    show={card.loading || card.busy}
                    onlyBlur={Boolean(card.row)}
                />
                {(!id || card.row) && (
                    <WarrantyFormik initial={card.row} save={card.save}>
                        <WarrantyForm card={card} canEdit={hasUserAccess(auth?.user, 'prodEdit')} />
                    </WarrantyFormik>
                )}
                {card.error && !card.row && <div className="text-danger px-3">{card.error}</div>}
            </Offcanvas.Body>
        </Offcanvas>
    );
};

export default OffWarrantyCard;
